import type {z} from "zod";

import {CreateServiceFunctionBody} from "@project/sdk/engineering/zod";

export const createServiceFunctionFormSchema = CreateServiceFunctionBody;
export type CreateServiceFunctionFormPayload = z.output<typeof createServiceFunctionFormSchema>;

export const draftCreateServiceFunctionFormSchema = createServiceFunctionFormSchema.partial();
export type DraftCreateServiceFunctionFormPayload = z.output<
  typeof draftCreateServiceFunctionFormSchema
>;
